import { Button as ButtonPrimitive } from "@base-ui/react"
import { cn, tv, VariantProps } from "@utils/tw"
import { useState } from "react"

const buttonVariants = tv({
  base: [
    "group/button inline-flex theme-dark type-title-m [font-size:19px] antialiased px-4 py-2 border-0 appearance-none cursor-pointer bg-bg text-fg items-center justify-center gap-2",
    "has-[svg:last-child]:pr-2",
    "disabled:bg-bg-high disabled:text-fg-secondary",
    "transition-all",
  ],
  variants: {
    variant: {},
    size: {},
  },
  defaultVariants: {},
})

type Props = ButtonPrimitive.Props & VariantProps<typeof buttonVariants> & { className?: string; loading?: boolean }

function Button({ className, variant, size, loading, ...props }: Props) {
  const [_isLoading, setIsLoading] = useState(loading)

  const isLoading = loading || _isLoading

  return (
    <ButtonPrimitive
      data-slot="button"
      className={buttonVariants({ variant, size, className })}
      {...props}
      disabled={props.disabled || isLoading}
      onClick={(e) => {
        if (props.onClick) {
          const result = props.onClick(e) as any
          if (result instanceof Promise) {
            setIsLoading(true)
            result.finally(() => setIsLoading(false))
          }
        }
      }}
    />
  )
}

export { Button, buttonVariants }
